export function numberWithSpaces(nr: number): string {
    return nr.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

export const numberWithCommas = (number: number): string => {
    return number.toLocaleString('en-US');
};
